<div class="dialog-container dialog-generic"
  role="dialog" 
  aria-describedby="dialog-title dialog-content"
  aria-modal="true">
  @if (data.type === 'confirm') {
    <img id="confirm-icon" alt="" src="/assets/images/logo.svg" >
  }
  <h1 id="dialog-title" mat-dialog-title aria-live="polite">{{ data.title }}</h1>
  <mat-dialog-content id="dialog-content">
    <div [innerHTML]="data.content" role="document" aria-live="polite"></div>
  </mat-dialog-content>
  
  <div class="dialog-button-container dialog-button-container-generic">
    <button i18n class="button-primary" aria-label="No, cancel and go back." i18n-aria-label (click)="onCancel()">NO</button>
    <button i18n class="button-primary" aria-label="Yes, confirm." i18n-aria-label (click)="onConfirm()">YES</button>
  </div>
</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>